const image = {
  companyLogo: '/assets/images/ic-company-logo.png',
  idmLogo: '/assets/images/ic-idm-logo.png',
  campLogo: '/assets/images/ic-camp-logo.png',
  mainIllustration: '/assets/images/ic-main-illustration.svg',
};

export default image;
